import axios from "axios";
import { NotImplementedError } from "../../errors";
import { PromiseHandler } from "../../handlers";
import { creativeJobFromService } from "../../models/aiCreative";
import { AiCreativeJobsFetchFailed } from "./errors";
/**
 * `GET /api/v1/creative/lists` (the Library listing endpoint) — a single-endpoint
 * sub-module, split out from the places-search handler it used to share a
 * `PromiseHandler` with (same split as {@link BrandAnalysis}/{@link GenerateJobs}).
 */
export default class Jobs extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "aiCreative.jobs");
    }
    async findItems(filters = {}) {
        const status = filters.where?.find((clause) => clause.field === "status")?.value;
        const advertiser = filters.where?.find((clause) => clause.field === "advertiser")?.value;
        const offset = filters.where?.find((clause) => clause.field === "offset")?.value;
        try {
            const res = await axios.get(`${this.sdk.urls.creativeBaseUrl}/api/v1/creative/lists`, {
                params: {
                    status,
                    advertiser: advertiser || undefined,
                    limit: filters.paging?.size,
                    offset
                }
            });
            return res.data.map(creativeJobFromService);
        }
        catch (err) {
            throw new AiCreativeJobsFetchFailed(err);
        }
    }
    /**
     * @deprecated
     * `save` is not supported — jobs are only created via generate-jobs, not
     * saved back through this listing endpoint.
     */
    saveItem() {
        throw new NotImplementedError("save");
    }
    /**
     * @deprecated
     * `delete` is not supported — jobs are not removable through this API.
     */
    deleteItem() {
        throw new NotImplementedError("delete");
    }
    /**
     * @deprecated
     * `make` is not supported — a job only exists once generate-jobs has
     * enqueued it.
     */
    async make() {
        throw new NotImplementedError("make");
    }
}
//# sourceMappingURL=jobs.js.map